<div class="d-flex align-items-center justify-content-center">
  <div class="container shadow-sm">
    <div class="container-body">
      <svg
        class="cta-icon"
        fill="#FFF"
        width="28px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xml:space="preserve">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <g>
            <g>
              <path
                d="M500.364,256c-6.982,0-11.636,4.655-11.636,11.636v139.636c0,5.818-2.327,11.636-6.982,16.291s-10.473,6.982-16.291,6.982 H46.545c-12.8,0-23.273-10.473-23.273-23.273V162.909h430.545c6.982,0,11.636-4.655,11.636-11.636 c0-6.982-4.655-11.636-11.636-11.636H11.636C4.655,139.636,0,144.291,0,151.273v256c0,25.6,20.945,46.545,46.545,46.545h418.909 c12.8,0,24.436-4.655,32.582-13.964c9.309-9.309,13.964-20.945,13.964-32.582V267.636C512,260.655,507.345,256,500.364,256z"></path>
            </g>
          </g>
          <g>
            <g>
              <path
                d="M139.636,360.727H58.182c-6.982,0-11.636,4.655-11.636,11.636S51.2,384,58.182,384h81.455 c6.982,0,11.636-4.655,11.636-11.636S146.618,360.727,139.636,360.727z"></path>
            </g>
          </g>
          <g>
            <g>
              <path
                d="M232.727,360.727h-46.545c-6.982,0-11.636,4.655-11.636,11.636S179.2,384,186.182,384h46.545 c6.982,0,11.636-4.655,11.636-11.636S239.709,360.727,232.727,360.727z"></path>
            </g>
          </g>
          <g>
            <g>
              <path
                d="M453.818,360.727h-46.545c-6.982,0-11.636,4.655-11.636,11.636S400.291,384,407.273,384h46.545 c6.982,0,11.636-4.655,11.636-11.636S460.8,360.727,453.818,360.727z"></path>
            </g>
          </g>
          <g>
            <g>
              <path
                d="M465.455,58.182H46.545C20.945,58.182,0,79.127,0,104.727c0,6.982,4.655,11.636,11.636,11.636s11.636-4.655,11.636-11.636 c0-12.8,10.473-23.273,23.273-23.273h418.909c12.8,0,23.273,10.473,23.273,23.273v104.727H58.182 c-6.982,0-11.636,4.655-11.636,11.636c0,6.982,4.655,11.636,11.636,11.636h442.182c6.982,0,11.636-4.655,11.636-11.636V104.727 C512,79.127,491.055,58.182,465.455,58.182z"></path>
            </g>
          </g>
        </g>
      </svg>
      <h1 class="cta-text">Parcele seus ingressos</h1>
    </div>
  </div>
</div>
